import React from 'react';
import './breadcrumbs.global.css';
import { CLICK, track } from '@updater-core/lib/tracker';

/**
 * Displays as a single breadcrumb. Displays as not clickable if `onClick` is
 * not provided.
 * @param {Function} onClick A function used to direct the user to wherever the
 * breadcrumb should take the user.
 * @param {Object} children The text content of the breadcrumb
 */
export function Breadcrumb({ children, onClick }) {
  const isNonInteractive = typeof onClick !== 'function';
  const classList = `app-navigation-breadcrumb ${
    isNonInteractive ? 'app-navigation-non-interactive-breadcrumb' : ''
  }`;
  return isNonInteractive ? (
    <div className={classList}>{children}</div>
  ) : (
    <a className={classList} onClick={onClick}>
      {children}
    </a>
  );
}

/**
 * Renders a list of breadcrumbs with a default `home` breadcrumb.
 * On small screens only `home` will be rendered.
 * @param {Function} onHome A function used to direct the user to home.
 * Automatically tracks with `mover.home_breadcrumb.clicked`. Add additional
 * tracking to the function if necessary.
 * @param {Object} children The breadcrumbs to be displayed.
 * @example
 *  render(
 *   <Breadcrumbs onHome={goToDashboard}>
 *     <Breadcrumb> Claim Exclusive Deals </Breadcrumb>
 *   </Breadcrumbs>,
 *   document.querySelector('#breadcrumbs')
 * );
 */
export function Breadcrumbs({ onHome, children }) {
  return (
    <div className="app-navigation-breadcrumbs">
      <Breadcrumb
        className="app-navigation-breadcrumb"
        onClick={() => {
          track({
            object: 'home_breadcrumb',
            verb: CLICK,
          });
          onHome();
        }}
      >
        Home
      </Breadcrumb>
      {children}
    </div>
  );
}
